import * as types from '../actions';

export default function setShowScanInfoTable(show) {
  return {
    type: types.VIEWER_SET_SHOW_SCAN_INFO_TABLE,
    show,
  };
}
